import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

/**
 * TransactionPieChart - Shows distribution of transactions by category
 */
const TransactionPieChart = ({ purchaseTransactions, saleTransactions, additionalTransactions }) => {
    const prepareData = () => {
        const totalPurchase = purchaseTransactions?.reduce((sum, t) => sum + parseFloat(t.amount || 0), 0) || 0;
        const totalSale = saleTransactions?.reduce((sum, t) => sum + parseFloat(t.amount || 0), 0) || 0;
        const totalCosts = additionalTransactions?.reduce((sum, t) => sum + parseFloat(t.amount || 0), 0) || 0;

        return [
            { name: 'Purchase', value: totalPurchase, color: '#ef4444' },
            { name: 'Sale', value: totalSale, color: '#10b981' },
            { name: 'Additional Costs', value: totalCosts, color: '#f59e0b' }
        ].filter(item => item.value > 0);
    };

    const data = prepareData();

    const formatCurrency = (value) => {
        return `₹${value.toLocaleString('en-IN')}`;
    };

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const data = payload[0];
            const total = payload[0].payload.payload.value;
            return (
                <div style={{
                    backgroundColor: 'white',
                    padding: '12px',
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                }}>
                    <p style={{ margin: '0 0 4px 0', fontWeight: 'bold', color: data.payload.color }}>
                        {data.name}
                    </p>
                    <p style={{ margin: '4px 0', fontSize: '1.1rem' }}>
                        {formatCurrency(total)}
                    </p>
                    <p style={{ margin: '4px 0 0 0', fontSize: '0.9rem', color: '#666' }}>
                        {data.payload.percent}%
                    </p>
                </div>
            );
        }
        return null;
    };

    const renderLabel = (entry) => {
        return `${entry.name}: ${entry.percent}%`;
    };

    if (!data || data.length === 0) {
        return (
            <div style={{
                padding: '40px',
                textAlign: 'center',
                color: '#666',
                backgroundColor: '#f9fafb',
                borderRadius: '8px'
            }}>
                <p style={{ fontSize: '1.1rem', marginBottom: '8px' }}>📊 No transaction data available</p>
                <p style={{ fontSize: '0.9rem' }}>Add transactions to see the breakdown</p>
            </div>
        );
    }

    return (
        <div>
            <h3 style={{ marginBottom: '16px', color: '#1a1a2e' }}>📈 Transaction Breakdown</h3>
            <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        label={renderLabel}
                        outerRadius={100}
                        fill="#8884d8"
                        dataKey="value"
                    >
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Pie>
                    <Tooltip content={<CustomTooltip />} />
                    <Legend />
                </PieChart>
            </ResponsiveContainer>

            {/* Summary Stats */}
            <div style={{
                marginTop: '16px',
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                gap: '12px'
            }}>
                {data.map((item, index) => (
                    <div key={index} style={{
                        padding: '12px',
                        backgroundColor: '#f9fafb',
                        borderRadius: '8px',
                        borderLeft: `4px solid ${item.color}`
                    }}>
                        <div style={{ fontSize: '0.85rem', color: '#666', marginBottom: '4px' }}>
                            {item.name}
                        </div>
                        <div style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#1a1a2e' }}>
                            {formatCurrency(item.value)}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TransactionPieChart;
